import React, { useEffect } from "react";

import { Col, Container, Button, Row } from "reactstrap";

import { connect } from "react-redux";
import { requestClass } from "../../../redux/actions/class_request_form";
import { fetchSubjectsByQualification } from "../../../redux/actions/api_subject";
import { createLoadingSelector } from "../../../redux/selectors";

import ImageJumbotron from "../../../components/ImageJumbotron";
import PackageCard from "../../../components/PackageCard";
import BottomBar from "../../../components/BottomBar";
import { Bell } from "react-feather";
import { getQualId } from "../../../helpers/qualificationIdentifier";

import Loader from "../../../components/Loader";

const IB = ({
  fetchSubjectsByQualification,
  requestClass,
  history,
  isLoading,
  subjects,
}) => {
  useEffect(() => {
    const id = getQualId("ib");
    fetchSubjectsByQualification(id);
  }, [fetchSubjectsByQualification]);

  const handleClick = () => {
    requestClass({ id: getQualId("ib"), name: "IB" });
    history.push("/page/class/request");
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <ImageJumbotron bg="banner3.jpg">
        <Container className="product_container">
          <Row>
            <Col md={6} sm={12}>
              <h1>IB Diploma</h1>
              <h4>1:1 Online Class</h4>
              <p>
                IB 란 International Baccalaureate 의 약자로 전 세계적으로
                인정받는 시험입니다. 국제적인 이해력을 증진할 수 있는 국제 인증
                대학 입학 자격증입니다. 전 세계적으로 수많은 학교가 도입한
                교육과정으로, 지식습득 위주의 공부보다는 전반적인 학문적 이해,
                문제해결 능력 등에 교육 초점이 맞춰져 있어서 대학입학 및 대학
                생활에 보다 빨리 적응할 수 있는 커리큘럼입니다.
              </p>
              <p>
                IB 과목 선택을 하기전에 목표 대학, 전공, 커리어등 여러가지
                조건들을 고려해서 선택하는것이{" "}
                <span className="highlight">매우 중요합니다!</span>
              </p>
              <p>
                저희 <span className="highlight">오버더문</span>에서는{" "}
                <span className="highlight">맞춤형 컨설팅</span>을 통해 학생의{" "}
                <span className="highlight">특성, 목표 대학교, 장래희망</span>
                등을 고려해서{" "}
                <span className="highlight">강사님을 매칭해드립니다.</span>
              </p>
              <p>
                해외 곳곳에 위치한{" "}
                <span className="highlight">명문대 출신</span> 강사님들을 통해
                <span className="highlight"> 1:1 맞춤형</span> 온라인 강의를
                받아보세요.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <PackageCard
                subjects={subjects}
                qualification="IB"
                classMethod="비대면"
                targetAudience="고등학생 (1,2학년)"
                onClick={handleClick}
              />
            </Col>
          </Row>
        </Container>
      </ImageJumbotron>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Button
              color="danger"
              style={{ width: "100%" }}
              onClick={handleClick}
            >
              수강 신청하기
            </Button>
          </Col>
        </Row>
      </BottomBar>
      <div className="site-section mt-0 pt-4">
        <Container className="class-page">
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>IB Diploma 커리큘럼</h2>
                <hr />
              </div>
              <div className="col-md-6">
                <ul>
                  <li>
                    IB Diploma Programme (DP) 는 대체적으로 대학 입시용 고등
                    과정입니다.
                  </li>
                  <li>
                    2년간 총 6개의 주요과목과 3개의 추가요건을 이수하는
                    제도입니다.
                  </li>
                  <li>
                    6개 과목중 3개의 심화과정 (HL, Higher Level), 3개의 표준과정
                    (SL, Standard Level)을 이수해야 합니다.
                  </li>
                  <li>
                    3개의 추가요건 (DP Core)는: Theory of Knowledge (TOK),
                    Extended Essay (EE), Creativity-Activity-Service (CAS) 로
                    구성 되어 있습니다.
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <img
                  src={require("../../../assets/img/IB_logo.jpg")}
                  className="img-fluid"
                  alt="ib_logo"
                />
              </div>
            </div>
          </div>
          <div className="sub-section">
            <h2>IB DP Core</h2>
            <hr />
            <div className="row">
              <div className="col-md-6">
                <img
                  src={require("../../../assets/img/IB_core_tok.png")}
                  className="img-fluid"
                  width="100%"
                  alt=" "
                />
              </div>

              <div className="col-md-6">
                <img
                  src={require("../../../assets/img/IB_core_ee.png")}
                  className="img-fluid"
                  alt=" "
                />
              </div>

              <div className="col-md-6">
                <img
                  src={require("../../../assets/img/IB_core_cas.png")}
                  className="img-fluid"
                  alt=" "
                />
              </div>
            </div>
          </div>
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>과목 선정 및 조합</h2>
                <hr />
              </div>
              <div className="col-md-12">
                <p>
                  과목 선택은 총 6개의 Subject Area 중 각 1개씩 이수해야합니다.
                  단, The Arts (예술)은 선택 과목입니다. 대신, 다른 Subject Area
                  에서 한개 과목을 추가적으로 들어서 총 6개 과목을 선택해야
                  합니다. 6개 과목중에 3개는 Standard Level (SL), 3개는 Higher
                  level (HL) 과목으로 선택해야 합니다.
                </p>
                <p className="text-center">
                  <img
                    src={require("../../../assets/img/IB_subjects.png")}
                    className="img-fluid"
                    alt=" "
                  />
                </p>
              </div>
            </div>
          </div>
          <div className="sub-section">
            <h2>오버더문 수업 진행 절차</h2>
            <hr />
            <p className="text-center">
              <img
                src={require("../../../assets/img/IB_process.png")}
                className="img-fluid"
                alt=" "
              />
            </p>
          </div>
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>성적평가와 대학 진학</h2>
                <hr />
              </div>
              <div className="col-md-12">
                <p>
                  각 Subject Area 과목들은 7점이 만점으로 평가되고 있으며 선택한
                  6 과목을 통해 최대 42점을 받을 수 있고 부과목인 TOK, CAS, EE
                  등의 추가 이수 요건들을 통해 추가 3점을 더 받아 IB의 최고점인
                  45점을 받을 수 있습니다.
                </p>
                <p className="text-center">
                  <img
                    src={require("../../../assets/img/IB_grades.png")}
                    className="img-fluid"
                    alt=" "
                  />
                </p>
              </div>
            </div>
          </div>
          <div className="sub-section">
            <h2>상담 문의</h2>
            <hr />
            <p className="text-center">
              <a
                href="https://pf.kakao.com/_xdNrsT"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../../../assets/img/kakaoplus.png")}
                  className="img-fluid"
                  alt="kakaoplus"
                />
              </a>
            </p>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const loadingSelector = createLoadingSelector(["FETCH_SUBJECTS"]);

const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
  subjects: state.api_subject.subjects,
});

const mapDispatchToProps = (dispatch) => ({
  requestClass: (class_type) => dispatch(requestClass(class_type)),
  fetchSubjectsByQualification: (qualification) =>
    dispatch(fetchSubjectsByQualification(qualification)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IB);
